export const buildSearchOptions = ({ query, currentPage, itemsPerPage }) => {
  const searchOptions = {
    b_start: (currentPage - 1) * itemsPerPage,
    b_size: itemsPerPage,
    metadata_fields: ['Title', 'short_description', '@id', '@type'],
    use_site_search_settings: true,
  };

  if (query) {
    searchOptions.SearchableText = query;
  }

  return searchOptions;
};
